import script from "./PercobaanPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PercobaanPage.vue?vue&type=script&setup=true&lang=js"

import "./PercobaanPage.vue?vue&type=style&index=0&id=e074dab6&scoped=true&lang=css"

import exportComponent from "C:\\wisata-jepara-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e074dab6"]])

export default __exports__